import { useEffect } from "react";
import { useAuth } from "../../contexts/auth/Context";
import { decodeUserInfo } from "../../utils/user";

export const usePageTitle = (pageTitle?: string) => {
  const { token } = useAuth();
  const { gymName } = decodeUserInfo(token);

  useEffect(() => {
    const baseTitle = "DashCore AI";
    const gymNamePart = gymName ? ` - ${gymName}` : "";
    const pageTitlePart = pageTitle ? ` - ${pageTitle}` : "";

    document.title = `${baseTitle}${gymNamePart}${pageTitlePart}`;
  }, [gymName, pageTitle]);
};
